import http from "@/libs/http";
const sports = {
  /**修改省市操作员的登录密码 */
  sportsUpdatePWD: UpdateProvincePrincipalPasswordVO => {
    return http.post(http.formatUrl("sports/authority/update/password"), UpdateProvincePrincipalPasswordVO);
  },
  /**设置省市操作员的账号启用禁用 */
  sportsUpdateStatus: UpdateUserStatusVO => {
    return http.post(http.formatUrl("sports/authority/update/user/status"), UpdateUserStatusVO);
  },
  /**获取省市体育局操作员分页列表*/
  sportsAuthorityPageList: SportsPageListVO => {
    return http.get(http.formatUrl("sports/authority/pageList"), SportsPageListVO);
  }
};
export default sports;
